import { Outlet } from 'react-router'

import PrivateRoute from '@app/guards/private-route'

import { PersonalNav } from '@widgets/personal/nav'
import { PersonalProfile } from '@widgets/personal/profile'

import Container from '@shared/ui/container'

import styles from './styles.module.scss'

export default function PersonalLayout () {
  return (
    <PrivateRoute>
      <Container>
        <div className={styles.root}>
          <div className={styles.root__left}>
            <PersonalProfile />
            <PersonalNav />
          </div>
          <Outlet />
        </div>
        <PersonalNav isBottomNavVariant />
      </Container>
    </PrivateRoute>
  )
}
